import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/scenarios',
      name: 'scenarios',
      component: () => import('./views/Scenarios.vue')
    },
    {
      path: '/scenarios/military',
      name: 'military',
      component: () => import('./views/Military.vue'),
      children: [{
        path: 'intro',
        component: () => import('./views/MilitarySubViews/intro.vue'),
      }, {
        path: 'step1',
        component: () => import('./views/MilitarySubViews/step1.vue'),
      }, {
        path: 'step2',
        component: () => import('./views/MilitarySubViews/step2.vue'),
      }, {
        path: 'step3',
        component: () => import('./views/MilitarySubViews/step3.vue'),
      }, {
        path: 'step4',
        component: () => import('./views/MilitarySubViews/step4.vue'),
      }, {
        path: 'step5',
        component: () => import('./views/MilitarySubViews/step5.vue'),
      }, {
        path: 'step6',
        component: () => import('./views/MilitarySubViews/step6.vue'),
      }, {
        path: 'step7',
        component: () => import('./views/MilitarySubViews/step7.vue'),
      }, {
        path: 'step8',
        component: () => import('./views/MilitarySubViews/step8.vue'),
      }, {
        path: 'step9',
        component: () => import('./views/MilitarySubViews/step9.vue'),
      }]
    },
    {
      path: '/scenarios/civilian-chemical',
      name: 'civilian-chemical',
      component: () => import('./views/CivilianChemical.vue'),
      children: [{
        path: 'intro',
        component: () => import('./views/CivilianChemicalSubViews/intro.vue'),
      }, {
        path: 'step1',
        component: () => import('./views/CivilianChemicalSubViews/step1.vue'),
      }, {
        path: 'step2',
        component: () => import('./views/CivilianChemicalSubViews/step2.vue'),
      }, {
        path: 'step3',
        component: () => import('./views/CivilianChemicalSubViews/step3.vue'),
      }, {
        path: 'step4',
        component: () => import('./views/CivilianChemicalSubViews/step4.vue'),
      }, {
        path: 'step5',
        component: () => import('./views/CivilianChemicalSubViews/step5.vue'),
      }, {
        path: 'step6',
        component: () => import('./views/CivilianChemicalSubViews/step6.vue'),
      }, {
        path: 'step7',
        component: () => import('./views/CivilianChemicalSubViews/step7.vue'),
      }, {
        path: 'step8',
        component: () => import('./views/CivilianChemicalSubViews/step8.vue'),
      }, {
        path: 'step9',
        component: () => import('./views/CivilianChemicalSubViews/step9.vue'),
      }, {
        path: 'step10',
        component: () => import('./views/CivilianChemicalSubViews/step10.vue'),
      }]
    },
    {
      path: '/scenarios/civilian-biological',
      name: 'civilian-biological',
      component: () => import('./views/CivilianBiological.vue'),
      children: [{
        path: 'intro',
        component: () => import('./views/CivilianBiologicalSubViews/intro.vue'),
      }, {
        path: 'step1',
        component: () => import('./views/CivilianBiologicalSubViews/step1.vue'),
      }, {
        path: 'step2',
        component: () => import('./views/CivilianBiologicalSubViews/step2.vue'),
      }, {
        path: 'step3',
        component: () => import('./views/CivilianBiologicalSubViews/step3.vue'),
      }, {
        path: 'step4',
        component: () => import('./views/CivilianBiologicalSubViews/step4.vue'),
      }, {
        path: 'step5',
        component: () => import('./views/CivilianBiologicalSubViews/step5.vue'),
      }, {
        path: 'step6',
        component: () => import('./views/CivilianBiologicalSubViews/step6.vue'),
      }, {
        path: 'step7',
        component: () => import('./views/CivilianBiologicalSubViews/step7.vue'),
      }, {
        path: 'step8',
        component: () => import('./views/CivilianBiologicalSubViews/step8.vue'),
      }, {
        path: 'step9',
        component: () => import('./views/CivilianBiologicalSubViews/step9.vue'),
      }]
    },
    {
      path: '/scenarios/civilian-radiological',
      name: 'civilian-radiological',
      component: () => import('./views/CivilianRadiological.vue'),
      children: [{
        path: 'intro',
        component: () => import('./views/CivilianRadiologicalSubViews/intro.vue'),
      }, {
        path: 'step1',
        component: () => import('./views/CivilianRadiologicalSubViews/step1.vue'),
      }, {
        path: 'step2',
        component: () => import('./views/CivilianRadiologicalSubViews/step2.vue'),
      }, {
        path: 'step3',
        component: () => import('./views/CivilianRadiologicalSubViews/step3.vue'),
      }, {
        path: 'step4',
        component: () => import('./views/CivilianRadiologicalSubViews/step4.vue'),
      }, {
        path: 'step5',
        component: () => import('./views/CivilianRadiologicalSubViews/step5.vue'),
      }, {
        path: 'step6',
        component: () => import('./views/CivilianRadiologicalSubViews/step6.vue'),
      }, {
        path: 'step7',
        component: () => import('./views/CivilianRadiologicalSubViews/step7.vue'),
      }, {
        path: 'step8',
        component: () => import('./views/CivilianRadiologicalSubViews/step8.vue'),
      }]
    },
    {
      path: '/cbrn-products',
      name: 'cbrn-products',
      component: () => import('./views/CBRNProducts.vue'),
    },
    {
      path: '/key-benefits',
      name: 'key-benefits',
      component: () => import(/* webpackChunkName: "key-benefits" */ './views/KeyBenefits.vue'),
      // meta: { transitionName: 'slide', modeType: 'in-out' }
    }
  ]
})
